import React, { Suspense, lazy } from 'react';
import { TopBanner } from './components/TopBanner';
import { HeroSection } from './components/HeroSection';
import { StickyOfferSmall } from './components/StickyOfferSmall';
// Lazy load below-the-fold components
const ComparisonTable = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const ProjectCarousel = lazy(() => import('./components/ProjectCarousel').then(m => ({
  default: m.ProjectCarousel
})));
const WhatYouGet = lazy(() => import('./components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const BonusGrid = lazy(() => import('./components/BonusGrid').then(m => ({
  default: m.BonusGrid
})));
const AntiScamSection = lazy(() => import('./components/AntiScamSection').then(m => ({
  default: m.AntiScamSection
})));
const PriceBox = lazy(() => import('./components/PriceBox').then(m => ({
  default: m.PriceBox
})));
const CommentsSection = lazy(() => import('./components/CommentsSection').then(m => ({
  default: m.CommentsSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const MetaPixel = lazy(() => import('./components/MetaPixel').then(m => ({
  default: m.MetaPixel
})));
export function App() {
  return <div className="min-h-screen bg-[#f5f0e1] font-body selection:bg-[#d4af37]/30 selection:text-[#0f1711] text-[#0f1711] relative overflow-x-hidden" data-id="element-0">
      {/* Side Herbal Decorations */}
      <div className="fixed inset-y-0 left-0 w-64 pointer-events-none z-0 opacity-20 hidden lg:block" data-id="element-1">
        <img src="https://cdn.magicpatterns.com/uploads/1kq9MpP8rtSuBkRCSgBcuc/ChatGPT_Image_27_may_2026,_22_42_14.png" alt="" className="h-full object-cover object-left" data-id="element-2" />
      </div>
      <div className="fixed inset-y-0 right-0 w-64 pointer-events-none z-0 opacity-20 hidden lg:block" data-id="element-3">
        <img src="https://cdn.magicpatterns.com/uploads/1kq9MpP8rtSuBkRCSgBcuc/ChatGPT_Image_27_may_2026,_22_42_14.png" alt="" className="h-full object-cover object-right" data-id="element-4" />
      </div>

      <Suspense fallback={null} data-id="element-5">
        <MetaPixel data-id="element-6" />
      </Suspense>

      <StickyOfferSmall data-id="element-7" />

      <div className="relative z-10" data-id="element-8">
        <div className="relative z-10" data-id="element-9">
          <TopBanner data-id="element-10" />
          <HeroSection data-id="element-11" />
        </div>
      </div>

      <main className="flex flex-col" data-id="element-12">
        <Suspense fallback={<div className="min-h-[400px]" data-id="element-14" />} data-id="element-13">
          <ComparisonTable data-id="element-15" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[600px]" data-id="element-17" />} data-id="element-16">
          <ProblemSection data-id="element-18" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[500px]" data-id="element-20" />} data-id="element-19">
          <ProjectCarousel data-id="element-21" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[600px]" data-id="element-23" />} data-id="element-22">
          <WhatYouGet data-id="element-24" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[800px]" data-id="element-26" />} data-id="element-25">
          <BonusGrid data-id="element-27" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[600px]" data-id="element-29" />} data-id="element-28">
          <AntiScamSection data-id="element-30" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[1000px]" data-id="element-32" />} data-id="element-31">
          <PriceBox data-id="element-33" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[800px]" data-id="element-35" />} data-id="element-34">
          <CommentsSection data-id="element-36" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[600px]" data-id="element-38" />} data-id="element-37">
          <TestimonialsSection data-id="element-39" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[600px]" data-id="element-41" />} data-id="element-40">
          <FAQSection data-id="element-42" />
        </Suspense>
      </main>
    </div>;
}